import { FormControl, Stack, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import TestTeamExternalIntegration from 'components/rbac-settings/teams/TestTeamExternalIntegration'
import { MonitorUrlFieldInput } from 'components/status-checks/form/status-check/common/MonitorUrlFieldInput'
import { StatusCheckSuccessEvaluation } from 'components/status-checks/form/status-check/StatusCheckSuccessEvaluation'
import { useAwsMonitorUrlFieldOnChangeHandler } from 'components/status-checks/hooks/use-aws-monitor-url-field-onchange-handler'
import {
  buildTeamExternalIntegration,
  type StatusCheckFormValues
} from 'components/status-checks/status-checks-form-utils'
import { useStatusCheckDetailsContext } from 'context/status-checks/StatusCheckDetailsContext'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

const fieldsToWatch = ['externalIntegration', 'observabilityTool'] as const

export const AWSMonitorSuccessEvaluation: React.FC = () => {
  const { control, getValues } = useFormContext<StatusCheckFormValues>()
  const [externalIntegration, observabilityTool] = useWatch<
    StatusCheckFormValues,
    typeof fieldsToWatch
  >({ control, name: fieldsToWatch })

  const isCustomObservabilityTool =
    observabilityTool.type === ObservabilityToolType.CUSTOM
  const isAWS = observabilityTool.type === ObservabilityToolType.AWS

  const handleMonitorUrlFieldChange = useAwsMonitorUrlFieldOnChangeHandler()
  const {
    handleSuccess,
    handleTestConnectionError,
    isTestStatusCheckDisabled
  } = useStatusCheckDetailsContext()

  return (
    <Stack spacing={3}>
      <FormControl>
        <Typography mb={2} mt={2}>
          What monitor or alert will help Gremlin determine the health of your
          Service?
        </Typography>
        <Controller
          control={control}
          name="monitorUrl"
          render={({ field, fieldState }) => (
            <MonitorUrlFieldInput
              externalIntegration={externalIntegration}
              field={field}
              fieldState={fieldState}
              label="Monitor or Alert URL"
              onChange={handleMonitorUrlFieldChange(field)}
            />
          )}
        />
        {(isCustomObservabilityTool || isAWS) && (
          <Stack mt={2} spacing={3}>
            <TestTeamExternalIntegration
              authenticate={false}
              buttonText="Test Connection"
              disabled={isTestStatusCheckDisabled}
              integration={buildTeamExternalIntegration(getValues())}
              onError={handleTestConnectionError}
              onResponseReceived={handleSuccess}
            />
            <StatusCheckSuccessEvaluation />
          </Stack>
        )}
      </FormControl>
    </Stack>
  )
}
